<script setup lang="ts">
import { computed } from 'vue';
import { useViewQuoteStore } from '@/store/ViewQuoteStore';

const viewQuoteStore = useViewQuoteStore();
const pdf = computed(() => {
  return viewQuoteStore.selectPdfQuote;
});
</script>
<template>
  <div class="flex justify-content-center" v-if="pdf">
    <embed :src="pdf" class="pdf-size" />
  </div>
</template>
<style lang="scss" scoped>
.pdf-size {
  width: 100%;
  height: 85vh;
}
</style>
